{{#each rows as |columns rowIndex|}}
<div class="row m-t-5" style="margin-right:-4px">
	{{#each columns as |value colIndex|}}
	{{#with (lookup ../../columnConfiguration @index) as |column|}}
		<div class="col-xs-{{width}}">
			{{#SWITCH column.inputType}}
				{{#CASE 'simple'}}
					<input
						type="{{contentType}}"
						class="form-control input-sm"
						name="{{column.namePrefix}}-{{@../index}}"
						placeholder="{{column.placeholder}}"
						value="{{value}}"
					/>
				{{/CASE}}
				{{#CASE 'select'}}
					{{#SELECT value.ID}}
						<select
							id="{{value.referenceID}}"
							class="selectpicker js-value-select"
							data-live-search="true"
							data-style="btn-white btn-sm"
							data-title="{{#if column.placeholder}}{{column.placeholder}}{{else}}{{TR 'Wert auswählen'}}{{/if}}">
							{{#each column.values}}
								<option value="{{this.cid}}">{{TR_DATAPOINT_CATEGORY this.attributes.group this.attributes.name}}</option>
							{{/each}}
						</select>
					{{/SELECT}}
				{{/CASE}}
				{{#CASE 'value'}}
					{{#FIELD_VALUE value.key value.name value.object value.key '' 'sm'}} {{/FIELD_VALUE}}
				{{/CASE}}
			{{/SWITCH}}
		</div>
	{{/with}}
	{{/each}}
	<div class="col-xs-1">
		<button
			id="{{../deleteButtonIDPrefix}}-{{rowIndex}}"
			class="{{../deleteButtonClass}} btn-sm btn-white">
			<i class="fa fa-trash" />
		</button>
	</div>
</div>
{{/each}}

